// source: pushwoosh/applications/applications.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() {
  if (this) { return this; }
  if (typeof window !== 'undefined') { return window; }
  if (typeof global !== 'undefined') { return global; }
  if (typeof self !== 'undefined') { return self; }
  return Function('return this')();
}.call(null));

var google_api_annotations_pb = require('../../google/api/annotations_pb.js');
goog.object.extend(proto, google_api_annotations_pb);
var pushwoosh_applications_info_applications_info_pb = require('../../pushwoosh/applications_info/applications_info_pb.js');
goog.object.extend(proto, pushwoosh_applications_info_applications_info_pb);
goog.exportSymbol('proto.pushwoosh.rpc_v2.applications.Application', null, global);
goog.exportSymbol('proto.pushwoosh.rpc_v2.applications.ApplicationPermissions', null, global);
goog.exportSymbol('proto.pushwoosh.rpc_v2.applications.ApplicationPlatformSubscribersCount', null, global);
goog.exportSymbol('proto.pushwoosh.rpc_v2.applications.ApplicationSummary', null, global);
goog.exportSymbol('proto.pushwoosh.rpc_v2.applications.CreateApplicationRequest', null, global);
goog.exportSymbol('proto.pushwoosh.rpc_v2.applications.CreateApplicationResponse', null, global);
goog.exportSymbol('proto.pushwoosh.rpc_v2.applications.DeleteApplicationRequest', null, global);
goog.exportSymbol('proto.pushwoosh.rpc_v2.applications.DeleteApplicationResponse', null, global);
goog.exportSymbol('proto.pushwoosh.rpc_v2.applications.GetApplicationRequest', null, global);
goog.exportSymbol('proto.pushwoosh.rpc_v2.applications.GetApplicationResponse', null, global);
goog.exportSymbol('proto.pushwoosh.rpc_v2.applications.ListApplicationsRequest', null, global);
goog.exportSymbol('proto.pushwoosh.rpc_v2.applications.ListApplicationsRequest.OrderBy', null, global);
goog.exportSymbol('proto.pushwoosh.rpc_v2.applications.ListApplicationsRequest.OrderDirection', null, global);
goog.exportSymbol('proto.pushwoosh.rpc_v2.applications.ListApplicationsResponse', null, global);
goog.exportSymbol('proto.pushwoosh.rpc_v2.applications.SetShortenerConfigurationRequest', null, global);
goog.exportSymbol('proto.pushwoosh.rpc_v2.applications.SetShortenerConfigurationResponse', null, global);
goog.exportSymbol('proto.pushwoosh.rpc_v2.applications.UpdateApplicationRequest', null, global);
goog.exportSymbol('proto.pushwoosh.rpc_v2.applications.UpdateApplicationResponse', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.rpc_v2.applications.ApplicationPlatformSubscribersCount = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.rpc_v2.applications.ApplicationPlatformSubscribersCount, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.rpc_v2.applications.ApplicationPlatformSubscribersCount.displayName = 'proto.pushwoosh.rpc_v2.applications.ApplicationPlatformSubscribersCount';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.rpc_v2.applications.ApplicationPermissions = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.rpc_v2.applications.ApplicationPermissions, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.rpc_v2.applications.ApplicationPermissions.displayName = 'proto.pushwoosh.rpc_v2.applications.ApplicationPermissions';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.rpc_v2.applications.Application = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.rpc_v2.applications.Application, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.rpc_v2.applications.Application.displayName = 'proto.pushwoosh.rpc_v2.applications.Application';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.rpc_v2.applications.ApplicationSummary = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.rpc_v2.applications.ApplicationSummary, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.rpc_v2.applications.ApplicationSummary.displayName = 'proto.pushwoosh.rpc_v2.applications.ApplicationSummary';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.rpc_v2.applications.GetApplicationRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.rpc_v2.applications.GetApplicationRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.rpc_v2.applications.GetApplicationRequest.displayName = 'proto.pushwoosh.rpc_v2.applications.GetApplicationRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.rpc_v2.applications.GetApplicationResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.rpc_v2.applications.GetApplicationResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.rpc_v2.applications.GetApplicationResponse.displayName = 'proto.pushwoosh.rpc_v2.applications.GetApplicationResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.rpc_v2.applications.CreateApplicationRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.rpc_v2.applications.CreateApplicationRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.rpc_v2.applications.CreateApplicationRequest.displayName = 'proto.pushwoosh.rpc_v2.applications.CreateApplicationRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.rpc_v2.applications.CreateApplicationResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.rpc_v2.applications.CreateApplicationResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.rpc_v2.applications.CreateApplicationResponse.displayName = 'proto.pushwoosh.rpc_v2.applications.CreateApplicationResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.rpc_v2.applications.UpdateApplicationRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.rpc_v2.applications.UpdateApplicationRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.rpc_v2.applications.UpdateApplicationRequest.displayName = 'proto.pushwoosh.rpc_v2.applications.UpdateApplicationRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.rpc_v2.applications.UpdateApplicationResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.rpc_v2.applications.UpdateApplicationResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.rpc_v2.applications.UpdateApplicationResponse.displayName = 'proto.pushwoosh.rpc_v2.applications.UpdateApplicationResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.rpc_v2.applications.ListApplicationsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.rpc_v2.applications.ListApplicationsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.rpc_v2.applications.ListApplicationsRequest.displayName = 'proto.pushwoosh.rpc_v2.applications.ListApplicationsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.rpc_v2.applications.ListApplicationsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.pushwoosh.rpc_v2.applications.ListApplicationsResponse.repeatedFields_, null);
};
goog.inherits(proto.pushwoosh.rpc_v2.applications.ListApplicationsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.rpc_v2.applications.ListApplicationsResponse.displayName = 'proto.pushwoosh.rpc_v2.applications.ListApplicationsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.rpc_v2.applications.DeleteApplicationRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.rpc_v2.applications.DeleteApplicationRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.rpc_v2.applications.DeleteApplicationRequest.displayName = 'proto.pushwoosh.rpc_v2.applications.DeleteApplicationRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.rpc_v2.applications.DeleteApplicationResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.rpc_v2.applications.DeleteApplicationResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.rpc_v2.applications.DeleteApplicationResponse.displayName = 'proto.pushwoosh.rpc_v2.applications.DeleteApplicationResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.rpc_v2.applications.SetShortenerConfigurationRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.rpc_v2.applications.SetShortenerConfigurationRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.rpc_v2.applications.SetShortenerConfigurationRequest.displayName = 'proto.pushwoosh.rpc_v2.applications.SetShortenerConfigurationRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.rpc_v2.applications.SetShortenerConfigurationResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.rpc_v2.applications.SetShortenerConfigurationResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.rpc_v2.applications.SetShortenerConfigurationResponse.displayName = 'proto.pushwoosh.rpc_v2.applications.SetShortenerConfigurationResponse';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.rpc_v2.applications.ApplicationPlatformSubscribersCount.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.rpc_v2.applications.ApplicationPlatformSubscribersCount.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.rpc_v2.applications.ApplicationPlatformSubscribersCount} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.applications.ApplicationPlatformSubscribersCount.toObject = function(includeInstance, msg) {
  var f, obj = {
    pushEnabled: jspb.Message.getFieldWithDefault(msg, 3, 0),
    pushDisabled: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.rpc_v2.applications.ApplicationPlatformSubscribersCount}
 */
proto.pushwoosh.rpc_v2.applications.ApplicationPlatformSubscribersCount.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.rpc_v2.applications.ApplicationPlatformSubscribersCount;
  return proto.pushwoosh.rpc_v2.applications.ApplicationPlatformSubscribersCount.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.rpc_v2.applications.ApplicationPlatformSubscribersCount} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.rpc_v2.applications.ApplicationPlatformSubscribersCount}
 */
proto.pushwoosh.rpc_v2.applications.ApplicationPlatformSubscribersCount.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 3:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setPushEnabled(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setPushDisabled(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.rpc_v2.applications.ApplicationPlatformSubscribersCount.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.rpc_v2.applications.ApplicationPlatformSubscribersCount.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.rpc_v2.applications.ApplicationPlatformSubscribersCount} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.applications.ApplicationPlatformSubscribersCount.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPushEnabled();
  if (f !== 0) {
    writer.writeUint64(
      3,
      f
    );
  }
  f = message.getPushDisabled();
  if (f !== 0) {
    writer.writeUint64(
      4,
      f
    );
  }
};


/**
 * optional uint64 push_enabled = 3;
 * @return {number}
 */
proto.pushwoosh.rpc_v2.applications.ApplicationPlatformSubscribersCount.prototype.getPushEnabled = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.pushwoosh.rpc_v2.applications.ApplicationPlatformSubscribersCount} returns this
 */
proto.pushwoosh.rpc_v2.applications.ApplicationPlatformSubscribersCount.prototype.setPushEnabled = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional uint64 push_disabled = 4;
 * @return {number}
 */
proto.pushwoosh.rpc_v2.applications.ApplicationPlatformSubscribersCount.prototype.getPushDisabled = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.pushwoosh.rpc_v2.applications.ApplicationPlatformSubscribersCount} returns this
 */
proto.pushwoosh.rpc_v2.applications.ApplicationPlatformSubscribersCount.prototype.setPushDisabled = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.rpc_v2.applications.ApplicationPermissions.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.rpc_v2.applications.ApplicationPermissions.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.rpc_v2.applications.ApplicationPermissions} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.applications.ApplicationPermissions.toObject = function(includeInstance, msg) {
  var f, obj = {
    canSee: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
    canModify: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
    canDelete: jspb.Message.getBooleanFieldWithDefault(msg, 3, false),
    canSendMessages: jspb.Message.getBooleanFieldWithDefault(msg, 4, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.rpc_v2.applications.ApplicationPermissions}
 */
proto.pushwoosh.rpc_v2.applications.ApplicationPermissions.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.rpc_v2.applications.ApplicationPermissions;
  return proto.pushwoosh.rpc_v2.applications.ApplicationPermissions.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.rpc_v2.applications.ApplicationPermissions} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.rpc_v2.applications.ApplicationPermissions}
 */
proto.pushwoosh.rpc_v2.applications.ApplicationPermissions.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setCanSee(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setCanModify(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setCanDelete(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setCanSendMessages(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.rpc_v2.applications.ApplicationPermissions.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.rpc_v2.applications.ApplicationPermissions.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.rpc_v2.applications.ApplicationPermissions} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.applications.ApplicationPermissions.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCanSee();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getCanModify();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getCanDelete();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
  f = message.getCanSendMessages();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
};


/**
 * optional bool can_see = 1;
 * @return {boolean}
 */
proto.pushwoosh.rpc_v2.applications.ApplicationPermissions.prototype.getCanSee = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pushwoosh.rpc_v2.applications.ApplicationPermissions} returns this
 */
proto.pushwoosh.rpc_v2.applications.ApplicationPermissions.prototype.setCanSee = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional bool can_modify = 2;
 * @return {boolean}
 */
proto.pushwoosh.rpc_v2.applications.ApplicationPermissions.prototype.getCanModify = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pushwoosh.rpc_v2.applications.ApplicationPermissions} returns this
 */
proto.pushwoosh.rpc_v2.applications.ApplicationPermissions.prototype.setCanModify = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional bool can_delete = 3;
 * @return {boolean}
 */
proto.pushwoosh.rpc_v2.applications.ApplicationPermissions.prototype.getCanDelete = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pushwoosh.rpc_v2.applications.ApplicationPermissions} returns this
 */
proto.pushwoosh.rpc_v2.applications.ApplicationPermissions.prototype.setCanDelete = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};


/**
 * optional bool can_send_messages = 4;
 * @return {boolean}
 */
proto.pushwoosh.rpc_v2.applications.ApplicationPermissions.prototype.getCanSendMessages = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pushwoosh.rpc_v2.applications.ApplicationPermissions} returns this
 */
proto.pushwoosh.rpc_v2.applications.ApplicationPermissions.prototype.setCanSendMessages = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.rpc_v2.applications.Application.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.rpc_v2.applications.Application.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.rpc_v2.applications.Application} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.applications.Application.toObject = function(includeInstance, msg) {
  var f, obj = {
    code: jspb.Message.getFieldWithDefault(msg, 1, ""),
    title: jspb.Message.getFieldWithDefault(msg, 2, ""),
    iconUrl: jspb.Message.getFieldWithDefault(msg, 3, ""),
    isDemo: jspb.Message.getBooleanFieldWithDefault(msg, 4, false),
    platformsMap: (f = msg.getPlatformsMap()) ? f.toObject(includeInstance, proto.pushwoosh.rpc_v2.applications_info.ApplicationPlatformsInfo.PlatformInfo.toObject) : [],
    subscribersMap: (f = msg.getSubscribersMap()) ? f.toObject(includeInstance, proto.pushwoosh.rpc_v2.applications.ApplicationPlatformSubscribersCount.toObject) : [],
    languagesMap: (f = msg.getLanguagesMap()) ? f.toObject(includeInstance, undefined) : [],
    permissions: (f = msg.getPermissions()) && proto.pushwoosh.rpc_v2.applications.ApplicationPermissions.toObject(includeInstance, f),
    propertiesMap: (f = msg.getPropertiesMap()) ? f.toObject(includeInstance, undefined) : [],
    countersMap: (f = msg.getCountersMap()) ? f.toObject(includeInstance, undefined) : []
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.rpc_v2.applications.Application}
 */
proto.pushwoosh.rpc_v2.applications.Application.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.rpc_v2.applications.Application;
  return proto.pushwoosh.rpc_v2.applications.Application.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.rpc_v2.applications.Application} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.rpc_v2.applications.Application}
 */
proto.pushwoosh.rpc_v2.applications.Application.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCode(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTitle(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setIconUrl(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsDemo(value);
      break;
    case 5:
      var value = msg.getPlatformsMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readUint32, jspb.BinaryReader.prototype.readMessage, proto.pushwoosh.rpc_v2.applications_info.ApplicationPlatformsInfo.PlatformInfo.deserializeBinaryFromReader, 0, new proto.pushwoosh.rpc_v2.applications_info.ApplicationPlatformsInfo.PlatformInfo());
         });
      break;
    case 6:
      var value = msg.getSubscribersMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readUint32, jspb.BinaryReader.prototype.readMessage, proto.pushwoosh.rpc_v2.applications.ApplicationPlatformSubscribersCount.deserializeBinaryFromReader, 0, new proto.pushwoosh.rpc_v2.applications.ApplicationPlatformSubscribersCount());
         });
      break;
    case 7:
      var value = msg.getLanguagesMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readUint64, null, "", 0);
         });
      break;
    case 8:
      var value = new proto.pushwoosh.rpc_v2.applications.ApplicationPermissions;
      reader.readMessage(value,proto.pushwoosh.rpc_v2.applications.ApplicationPermissions.deserializeBinaryFromReader);
      msg.setPermissions(value);
      break;
    case 9:
      var value = msg.getPropertiesMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readString, null, "", "");
         });
      break;
    case 10:
      var value = msg.getCountersMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readUint64, null, "", 0);
         });
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.rpc_v2.applications.Application.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.rpc_v2.applications.Application.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.rpc_v2.applications.Application} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.applications.Application.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCode();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTitle();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getIconUrl();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getIsDemo();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
  f = message.getPlatformsMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(5, writer, jspb.BinaryWriter.prototype.writeUint32, jspb.BinaryWriter.prototype.writeMessage, proto.pushwoosh.rpc_v2.applications_info.ApplicationPlatformsInfo.PlatformInfo.serializeBinaryToWriter);
  }
  f = message.getSubscribersMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(6, writer, jspb.BinaryWriter.prototype.writeUint32, jspb.BinaryWriter.prototype.writeMessage, proto.pushwoosh.rpc_v2.applications.ApplicationPlatformSubscribersCount.serializeBinaryToWriter);
  }
  f = message.getLanguagesMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(7, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeUint64);
  }
  f = message.getPermissions();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      proto.pushwoosh.rpc_v2.applications.ApplicationPermissions.serializeBinaryToWriter
    );
  }
  f = message.getPropertiesMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(9, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeString);
  }
  f = message.getCountersMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(10, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeUint64);
  }
};


/**
 * optional string code = 1;
 * @return {string}
 */
proto.pushwoosh.rpc_v2.applications.Application.prototype.getCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.pushwoosh.rpc_v2.applications.Application} returns this
 */
proto.pushwoosh.rpc_v2.applications.Application.prototype.setCode = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string title = 2;
 * @return {string}
 */
proto.pushwoosh.rpc_v2.applications.Application.prototype.getTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.pushwoosh.rpc_v2.applications.Application} returns this
 */
proto.pushwoosh.rpc_v2.applications.Application.prototype.setTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string icon_url = 3;
 * @return {string}
 */
proto.pushwoosh.rpc_v2.applications.Application.prototype.getIconUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.pushwoosh.rpc_v2.applications.Application} returns this
 */
proto.pushwoosh.rpc_v2.applications.Application.prototype.setIconUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional bool is_demo = 4;
 * @return {boolean}
 */
proto.pushwoosh.rpc_v2.applications.Application.prototype.getIsDemo = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pushwoosh.rpc_v2.applications.Application} returns this
 */
proto.pushwoosh.rpc_v2.applications.Application.prototype.setIsDemo = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};


/**
 * map<uint32, pushwoosh.rpc_v2.applications_info.ApplicationPlatformsInfo.PlatformInfo> platforms = 5;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<number,!proto.pushwoosh.rpc_v2.applications_info.ApplicationPlatformsInfo.PlatformInfo>}
 */
proto.pushwoosh.rpc_v2.applications.Application.prototype.getPlatformsMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<number,!proto.pushwoosh.rpc_v2.applications_info.ApplicationPlatformsInfo.PlatformInfo>} */ (
      jspb.Message.getMapField(this, 5, opt_noLazyCreate,
      proto.pushwoosh.rpc_v2.applications_info.ApplicationPlatformsInfo.PlatformInfo));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.pushwoosh.rpc_v2.applications.Application} returns this
 */
proto.pushwoosh.rpc_v2.applications.Application.prototype.clearPlatformsMap = function() {
  this.getPlatformsMap().clear();
  return this;};


/**
 * map<uint32, ApplicationPlatformSubscribersCount> subscribers = 6;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<number,!proto.pushwoosh.rpc_v2.applications.ApplicationPlatformSubscribersCount>}
 */
proto.pushwoosh.rpc_v2.applications.Application.prototype.getSubscribersMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<number,!proto.pushwoosh.rpc_v2.applications.ApplicationPlatformSubscribersCount>} */ (
      jspb.Message.getMapField(this, 6, opt_noLazyCreate,
      proto.pushwoosh.rpc_v2.applications.ApplicationPlatformSubscribersCount));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.pushwoosh.rpc_v2.applications.Application} returns this
 */
proto.pushwoosh.rpc_v2.applications.Application.prototype.clearSubscribersMap = function() {
  this.getSubscribersMap().clear();
  return this;};


/**
 * map<string, uint64> languages = 7;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,number>}
 */
proto.pushwoosh.rpc_v2.applications.Application.prototype.getLanguagesMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,number>} */ (
      jspb.Message.getMapField(this, 7, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.pushwoosh.rpc_v2.applications.Application} returns this
 */
proto.pushwoosh.rpc_v2.applications.Application.prototype.clearLanguagesMap = function() {
  this.getLanguagesMap().clear();
  return this;};


/**
 * optional ApplicationPermissions permissions = 8;
 * @return {?proto.pushwoosh.rpc_v2.applications.ApplicationPermissions}
 */
proto.pushwoosh.rpc_v2.applications.Application.prototype.getPermissions = function() {
  return /** @type{?proto.pushwoosh.rpc_v2.applications.ApplicationPermissions} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.rpc_v2.applications.ApplicationPermissions, 8));
};


/**
 * @param {?proto.pushwoosh.rpc_v2.applications.ApplicationPermissions|undefined} value
 * @return {!proto.pushwoosh.rpc_v2.applications.Application} returns this
*/
proto.pushwoosh.rpc_v2.applications.Application.prototype.setPermissions = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.rpc_v2.applications.Application} returns this
 */
proto.pushwoosh.rpc_v2.applications.Application.prototype.clearPermissions = function() {
  return this.setPermissions(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.rpc_v2.applications.Application.prototype.hasPermissions = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * map<string, string> properties = 9;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,string>}
 */
proto.pushwoosh.rpc_v2.applications.Application.prototype.getPropertiesMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,string>} */ (
      jspb.Message.getMapField(this, 9, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.pushwoosh.rpc_v2.applications.Application} returns this
 */
proto.pushwoosh.rpc_v2.applications.Application.prototype.clearPropertiesMap = function() {
  this.getPropertiesMap().clear();
  return this;};


/**
 * map<string, uint64> counters = 10;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,number>}
 */
proto.pushwoosh.rpc_v2.applications.Application.prototype.getCountersMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,number>} */ (
      jspb.Message.getMapField(this, 10, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.pushwoosh.rpc_v2.applications.Application} returns this
 */
proto.pushwoosh.rpc_v2.applications.Application.prototype.clearCountersMap = function() {
  this.getCountersMap().clear();
  return this;};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.rpc_v2.applications.ApplicationSummary.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.rpc_v2.applications.ApplicationSummary.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.rpc_v2.applications.ApplicationSummary} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.applications.ApplicationSummary.toObject = function(includeInstance, msg) {
  var f, obj = {
    code: jspb.Message.getFieldWithDefault(msg, 1, ""),
    title: jspb.Message.getFieldWithDefault(msg, 2, ""),
    iconUrl: jspb.Message.getFieldWithDefault(msg, 3, ""),
    isDemo: jspb.Message.getBooleanFieldWithDefault(msg, 4, false),
    subscribersMap: (f = msg.getSubscribersMap()) ? f.toObject(includeInstance, proto.pushwoosh.rpc_v2.applications.ApplicationPlatformSubscribersCount.toObject) : [],
    platformsMap: (f = msg.getPlatformsMap()) ? f.toObject(includeInstance, proto.pushwoosh.rpc_v2.applications_info.ApplicationPlatformsInfo.PlatformInfo.toObject) : []
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.rpc_v2.applications.ApplicationSummary}
 */
proto.pushwoosh.rpc_v2.applications.ApplicationSummary.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.rpc_v2.applications.ApplicationSummary;
  return proto.pushwoosh.rpc_v2.applications.ApplicationSummary.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.rpc_v2.applications.ApplicationSummary} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.rpc_v2.applications.ApplicationSummary}
 */
proto.pushwoosh.rpc_v2.applications.ApplicationSummary.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCode(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTitle(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setIconUrl(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsDemo(value);
      break;
    case 5:
      var value = msg.getSubscribersMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readUint32, jspb.BinaryReader.prototype.readMessage, proto.pushwoosh.rpc_v2.applications.ApplicationPlatformSubscribersCount.deserializeBinaryFromReader, 0, new proto.pushwoosh.rpc_v2.applications.ApplicationPlatformSubscribersCount());
         });
      break;
    case 6:
      var value = msg.getPlatformsMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readUint32, jspb.BinaryReader.prototype.readMessage, proto.pushwoosh.rpc_v2.applications_info.ApplicationPlatformsInfo.PlatformInfo.deserializeBinaryFromReader, 0, new proto.pushwoosh.rpc_v2.applications_info.ApplicationPlatformsInfo.PlatformInfo());
         });
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.rpc_v2.applications.ApplicationSummary.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.rpc_v2.applications.ApplicationSummary.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.rpc_v2.applications.ApplicationSummary} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.applications.ApplicationSummary.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCode();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTitle();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getIconUrl();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getIsDemo();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
  f = message.getSubscribersMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(5, writer, jspb.BinaryWriter.prototype.writeUint32, jspb.BinaryWriter.prototype.writeMessage, proto.pushwoosh.rpc_v2.applications.ApplicationPlatformSubscribersCount.serializeBinaryToWriter);
  }
  f = message.getPlatformsMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(6, writer, jspb.BinaryWriter.prototype.writeUint32, jspb.BinaryWriter.prototype.writeMessage, proto.pushwoosh.rpc_v2.applications_info.ApplicationPlatformsInfo.PlatformInfo.serializeBinaryToWriter);
  }
};


/**
 * optional string code = 1;
 * @return {string}
 */
proto.pushwoosh.rpc_v2.applications.ApplicationSummary.prototype.getCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.pushwoosh.rpc_v2.applications.ApplicationSummary} returns this
 */
proto.pushwoosh.rpc_v2.applications.ApplicationSummary.prototype.setCode = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string title = 2;
 * @return {string}
 */
proto.pushwoosh.rpc_v2.applications.ApplicationSummary.prototype.getTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.pushwoosh.rpc_v2.applications.ApplicationSummary} returns this
 */
proto.pushwoosh.rpc_v2.applications.ApplicationSummary.prototype.setTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string icon_url = 3;
 * @return {string}
 */
proto.pushwoosh.rpc_v2.applications.ApplicationSummary.prototype.getIconUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.pushwoosh.rpc_v2.applications.ApplicationSummary} returns this
 */
proto.pushwoosh.rpc_v2.applications.ApplicationSummary.prototype.setIconUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional bool is_demo = 4;
 * @return {boolean}
 */
proto.pushwoosh.rpc_v2.applications.ApplicationSummary.prototype.getIsDemo = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pushwoosh.rpc_v2.applications.ApplicationSummary} returns this
 */
proto.pushwoosh.rpc_v2.applications.ApplicationSummary.prototype.setIsDemo = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};


/**
 * map<uint32, ApplicationPlatformSubscribersCount> subscribers = 5;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<number,!proto.pushwoosh.rpc_v2.applications.ApplicationPlatformSubscribersCount>}
 */
proto.pushwoosh.rpc_v2.applications.ApplicationSummary.prototype.getSubscribersMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<number,!proto.pushwoosh.rpc_v2.applications.ApplicationPlatformSubscribersCount>} */ (
      jspb.Message.getMapField(this, 5, opt_noLazyCreate,
      proto.pushwoosh.rpc_v2.applications.ApplicationPlatformSubscribersCount));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.pushwoosh.rpc_v2.applications.ApplicationSummary} returns this
 */
proto.pushwoosh.rpc_v2.applications.ApplicationSummary.prototype.clearSubscribersMap = function() {
  this.getSubscribersMap().clear();
  return this;};


/**
 * map<uint32, pushwoosh.rpc_v2.applications_info.ApplicationPlatformsInfo.PlatformInfo> platforms = 6;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<number,!proto.pushwoosh.rpc_v2.applications_info.ApplicationPlatformsInfo.PlatformInfo>}
 */
proto.pushwoosh.rpc_v2.applications.ApplicationSummary.prototype.getPlatformsMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<number,!proto.pushwoosh.rpc_v2.applications_info.ApplicationPlatformsInfo.PlatformInfo>} */ (
      jspb.Message.getMapField(this, 6, opt_noLazyCreate,
      proto.pushwoosh.rpc_v2.applications_info.ApplicationPlatformsInfo.PlatformInfo));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.pushwoosh.rpc_v2.applications.ApplicationSummary} returns this
 */
proto.pushwoosh.rpc_v2.applications.ApplicationSummary.prototype.clearPlatformsMap = function() {
  this.getPlatformsMap().clear();
  return this;};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.rpc_v2.applications.GetApplicationRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.rpc_v2.applications.GetApplicationRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.rpc_v2.applications.GetApplicationRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.applications.GetApplicationRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    code: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.rpc_v2.applications.GetApplicationRequest}
 */
proto.pushwoosh.rpc_v2.applications.GetApplicationRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.rpc_v2.applications.GetApplicationRequest;
  return proto.pushwoosh.rpc_v2.applications.GetApplicationRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.rpc_v2.applications.GetApplicationRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.rpc_v2.applications.GetApplicationRequest}
 */
proto.pushwoosh.rpc_v2.applications.GetApplicationRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCode(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.rpc_v2.applications.GetApplicationRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.rpc_v2.applications.GetApplicationRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.rpc_v2.applications.GetApplicationRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.applications.GetApplicationRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCode();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string code = 1;
 * @return {string}
 */
proto.pushwoosh.rpc_v2.applications.GetApplicationRequest.prototype.getCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.pushwoosh.rpc_v2.applications.GetApplicationRequest} returns this
 */
proto.pushwoosh.rpc_v2.applications.GetApplicationRequest.prototype.setCode = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.rpc_v2.applications.GetApplicationResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.rpc_v2.applications.GetApplicationResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.rpc_v2.applications.GetApplicationResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.applications.GetApplicationResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    application: (f = msg.getApplication()) && proto.pushwoosh.rpc_v2.applications.Application.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.rpc_v2.applications.GetApplicationResponse}
 */
proto.pushwoosh.rpc_v2.applications.GetApplicationResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.rpc_v2.applications.GetApplicationResponse;
  return proto.pushwoosh.rpc_v2.applications.GetApplicationResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.rpc_v2.applications.GetApplicationResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.rpc_v2.applications.GetApplicationResponse}
 */
proto.pushwoosh.rpc_v2.applications.GetApplicationResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.pushwoosh.rpc_v2.applications.Application;
      reader.readMessage(value,proto.pushwoosh.rpc_v2.applications.Application.deserializeBinaryFromReader);
      msg.setApplication(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.rpc_v2.applications.GetApplicationResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.rpc_v2.applications.GetApplicationResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.rpc_v2.applications.GetApplicationResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.applications.GetApplicationResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getApplication();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.pushwoosh.rpc_v2.applications.Application.serializeBinaryToWriter
    );
  }
};


/**
 * optional Application application = 1;
 * @return {?proto.pushwoosh.rpc_v2.applications.Application}
 */
proto.pushwoosh.rpc_v2.applications.GetApplicationResponse.prototype.getApplication = function() {
  return /** @type{?proto.pushwoosh.rpc_v2.applications.Application} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.rpc_v2.applications.Application, 1));
};


/**
 * @param {?proto.pushwoosh.rpc_v2.applications.Application|undefined} value
 * @return {!proto.pushwoosh.rpc_v2.applications.GetApplicationResponse} returns this
*/
proto.pushwoosh.rpc_v2.applications.GetApplicationResponse.prototype.setApplication = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.rpc_v2.applications.GetApplicationResponse} returns this
 */
proto.pushwoosh.rpc_v2.applications.GetApplicationResponse.prototype.clearApplication = function() {
  return this.setApplication(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.rpc_v2.applications.GetApplicationResponse.prototype.hasApplication = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.rpc_v2.applications.CreateApplicationRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.rpc_v2.applications.CreateApplicationRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.rpc_v2.applications.CreateApplicationRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.applications.CreateApplicationRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    title: jspb.Message.getFieldWithDefault(msg, 1, ""),
    icon: msg.getIcon_asB64()
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.rpc_v2.applications.CreateApplicationRequest}
 */
proto.pushwoosh.rpc_v2.applications.CreateApplicationRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.rpc_v2.applications.CreateApplicationRequest;
  return proto.pushwoosh.rpc_v2.applications.CreateApplicationRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.rpc_v2.applications.CreateApplicationRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.rpc_v2.applications.CreateApplicationRequest}
 */
proto.pushwoosh.rpc_v2.applications.CreateApplicationRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTitle(value);
      break;
    case 2:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setIcon(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.rpc_v2.applications.CreateApplicationRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.rpc_v2.applications.CreateApplicationRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.rpc_v2.applications.CreateApplicationRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.applications.CreateApplicationRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTitle();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getIcon_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      2,
      f
    );
  }
};


/**
 * optional string title = 1;
 * @return {string}
 */
proto.pushwoosh.rpc_v2.applications.CreateApplicationRequest.prototype.getTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.pushwoosh.rpc_v2.applications.CreateApplicationRequest} returns this
 */
proto.pushwoosh.rpc_v2.applications.CreateApplicationRequest.prototype.setTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional bytes icon = 2;
 * @return {!(string|Uint8Array)}
 */
proto.pushwoosh.rpc_v2.applications.CreateApplicationRequest.prototype.getIcon = function() {
  return /** @type {!(string|Uint8Array)} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * optional bytes icon = 2;
 * This is a type-conversion wrapper around `getIcon()`
 * @return {string}
 */
proto.pushwoosh.rpc_v2.applications.CreateApplicationRequest.prototype.getIcon_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getIcon()));
};


/**
 * optional bytes icon = 2;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getIcon()`
 * @return {!Uint8Array}
 */
proto.pushwoosh.rpc_v2.applications.CreateApplicationRequest.prototype.getIcon_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getIcon()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.pushwoosh.rpc_v2.applications.CreateApplicationRequest} returns this
 */
proto.pushwoosh.rpc_v2.applications.CreateApplicationRequest.prototype.setIcon = function(value) {
  return jspb.Message.setProto3BytesField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.rpc_v2.applications.CreateApplicationResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.rpc_v2.applications.CreateApplicationResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.rpc_v2.applications.CreateApplicationResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.applications.CreateApplicationResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    application: (f = msg.getApplication()) && proto.pushwoosh.rpc_v2.applications.Application.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.rpc_v2.applications.CreateApplicationResponse}
 */
proto.pushwoosh.rpc_v2.applications.CreateApplicationResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.rpc_v2.applications.CreateApplicationResponse;
  return proto.pushwoosh.rpc_v2.applications.CreateApplicationResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.rpc_v2.applications.CreateApplicationResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.rpc_v2.applications.CreateApplicationResponse}
 */
proto.pushwoosh.rpc_v2.applications.CreateApplicationResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.pushwoosh.rpc_v2.applications.Application;
      reader.readMessage(value,proto.pushwoosh.rpc_v2.applications.Application.deserializeBinaryFromReader);
      msg.setApplication(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.rpc_v2.applications.CreateApplicationResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.rpc_v2.applications.CreateApplicationResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.rpc_v2.applications.CreateApplicationResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.applications.CreateApplicationResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getApplication();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.pushwoosh.rpc_v2.applications.Application.serializeBinaryToWriter
    );
  }
};


/**
 * optional Application application = 1;
 * @return {?proto.pushwoosh.rpc_v2.applications.Application}
 */
proto.pushwoosh.rpc_v2.applications.CreateApplicationResponse.prototype.getApplication = function() {
  return /** @type{?proto.pushwoosh.rpc_v2.applications.Application} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.rpc_v2.applications.Application, 1));
};


/**
 * @param {?proto.pushwoosh.rpc_v2.applications.Application|undefined} value
 * @return {!proto.pushwoosh.rpc_v2.applications.CreateApplicationResponse} returns this
*/
proto.pushwoosh.rpc_v2.applications.CreateApplicationResponse.prototype.setApplication = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.rpc_v2.applications.CreateApplicationResponse} returns this
 */
proto.pushwoosh.rpc_v2.applications.CreateApplicationResponse.prototype.clearApplication = function() {
  return this.setApplication(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.rpc_v2.applications.CreateApplicationResponse.prototype.hasApplication = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.rpc_v2.applications.UpdateApplicationRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.rpc_v2.applications.UpdateApplicationRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.rpc_v2.applications.UpdateApplicationRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.applications.UpdateApplicationRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    code: jspb.Message.getFieldWithDefault(msg, 1, ""),
    title: jspb.Message.getFieldWithDefault(msg, 2, ""),
    icon: msg.getIcon_asB64()
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.rpc_v2.applications.UpdateApplicationRequest}
 */
proto.pushwoosh.rpc_v2.applications.UpdateApplicationRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.rpc_v2.applications.UpdateApplicationRequest;
  return proto.pushwoosh.rpc_v2.applications.UpdateApplicationRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.rpc_v2.applications.UpdateApplicationRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.rpc_v2.applications.UpdateApplicationRequest}
 */
proto.pushwoosh.rpc_v2.applications.UpdateApplicationRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCode(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTitle(value);
      break;
    case 3:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setIcon(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.rpc_v2.applications.UpdateApplicationRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.rpc_v2.applications.UpdateApplicationRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.rpc_v2.applications.UpdateApplicationRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.applications.UpdateApplicationRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCode();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTitle();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getIcon_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      3,
      f
    );
  }
};


/**
 * optional string code = 1;
 * @return {string}
 */
proto.pushwoosh.rpc_v2.applications.UpdateApplicationRequest.prototype.getCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.pushwoosh.rpc_v2.applications.UpdateApplicationRequest} returns this
 */
proto.pushwoosh.rpc_v2.applications.UpdateApplicationRequest.prototype.setCode = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string title = 2;
 * @return {string}
 */
proto.pushwoosh.rpc_v2.applications.UpdateApplicationRequest.prototype.getTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.pushwoosh.rpc_v2.applications.UpdateApplicationRequest} returns this
 */
proto.pushwoosh.rpc_v2.applications.UpdateApplicationRequest.prototype.setTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional bytes icon = 3;
 * @return {!(string|Uint8Array)}
 */
proto.pushwoosh.rpc_v2.applications.UpdateApplicationRequest.prototype.getIcon = function() {
  return /** @type {!(string|Uint8Array)} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * optional bytes icon = 3;
 * This is a type-conversion wrapper around `getIcon()`
 * @return {string}
 */
proto.pushwoosh.rpc_v2.applications.UpdateApplicationRequest.prototype.getIcon_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getIcon()));
};


/**
 * optional bytes icon = 3;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getIcon()`
 * @return {!Uint8Array}
 */
proto.pushwoosh.rpc_v2.applications.UpdateApplicationRequest.prototype.getIcon_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getIcon()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.pushwoosh.rpc_v2.applications.UpdateApplicationRequest} returns this
 */
proto.pushwoosh.rpc_v2.applications.UpdateApplicationRequest.prototype.setIcon = function(value) {
  return jspb.Message.setProto3BytesField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.rpc_v2.applications.UpdateApplicationResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.rpc_v2.applications.UpdateApplicationResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.rpc_v2.applications.UpdateApplicationResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.applications.UpdateApplicationResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    application: (f = msg.getApplication()) && proto.pushwoosh.rpc_v2.applications.Application.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.rpc_v2.applications.UpdateApplicationResponse}
 */
proto.pushwoosh.rpc_v2.applications.UpdateApplicationResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.rpc_v2.applications.UpdateApplicationResponse;
  return proto.pushwoosh.rpc_v2.applications.UpdateApplicationResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.rpc_v2.applications.UpdateApplicationResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.rpc_v2.applications.UpdateApplicationResponse}
 */
proto.pushwoosh.rpc_v2.applications.UpdateApplicationResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.pushwoosh.rpc_v2.applications.Application;
      reader.readMessage(value,proto.pushwoosh.rpc_v2.applications.Application.deserializeBinaryFromReader);
      msg.setApplication(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.rpc_v2.applications.UpdateApplicationResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.rpc_v2.applications.UpdateApplicationResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.rpc_v2.applications.UpdateApplicationResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.applications.UpdateApplicationResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getApplication();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.pushwoosh.rpc_v2.applications.Application.serializeBinaryToWriter
    );
  }
};


/**
 * optional Application application = 1;
 * @return {?proto.pushwoosh.rpc_v2.applications.Application}
 */
proto.pushwoosh.rpc_v2.applications.UpdateApplicationResponse.prototype.getApplication = function() {
  return /** @type{?proto.pushwoosh.rpc_v2.applications.Application} */ (
    jspb.Message.getWrapperField(this, proto.pushwoosh.rpc_v2.applications.Application, 1));
};


/**
 * @param {?proto.pushwoosh.rpc_v2.applications.Application|undefined} value
 * @return {!proto.pushwoosh.rpc_v2.applications.UpdateApplicationResponse} returns this
*/
proto.pushwoosh.rpc_v2.applications.UpdateApplicationResponse.prototype.setApplication = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.rpc_v2.applications.UpdateApplicationResponse} returns this
 */
proto.pushwoosh.rpc_v2.applications.UpdateApplicationResponse.prototype.clearApplication = function() {
  return this.setApplication(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.rpc_v2.applications.UpdateApplicationResponse.prototype.hasApplication = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.rpc_v2.applications.ListApplicationsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.rpc_v2.applications.ListApplicationsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.rpc_v2.applications.ListApplicationsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.applications.ListApplicationsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    orderBy: jspb.Message.getFieldWithDefault(msg, 1, 0),
    orderDirection: jspb.Message.getFieldWithDefault(msg, 2, 0),
    page: jspb.Message.getFieldWithDefault(msg, 3, 0),
    perPage: jspb.Message.getFieldWithDefault(msg, 4, 0),
    search: jspb.Message.getFieldWithDefault(msg, 5, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.rpc_v2.applications.ListApplicationsRequest}
 */
proto.pushwoosh.rpc_v2.applications.ListApplicationsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.rpc_v2.applications.ListApplicationsRequest;
  return proto.pushwoosh.rpc_v2.applications.ListApplicationsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.rpc_v2.applications.ListApplicationsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.rpc_v2.applications.ListApplicationsRequest}
 */
proto.pushwoosh.rpc_v2.applications.ListApplicationsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.pushwoosh.rpc_v2.applications.ListApplicationsRequest.OrderBy} */ (reader.readEnum());
      msg.setOrderBy(value);
      break;
    case 2:
      var value = /** @type {!proto.pushwoosh.rpc_v2.applications.ListApplicationsRequest.OrderDirection} */ (reader.readEnum());
      msg.setOrderDirection(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPage(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPerPage(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setSearch(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.rpc_v2.applications.ListApplicationsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.rpc_v2.applications.ListApplicationsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.rpc_v2.applications.ListApplicationsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.applications.ListApplicationsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOrderBy();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getOrderDirection();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getPage();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getPerPage();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getSearch();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.pushwoosh.rpc_v2.applications.ListApplicationsRequest.OrderBy = {
  TITLE: 0,
  SUBSCRIBERS: 1
};

/**
 * @enum {number}
 */
proto.pushwoosh.rpc_v2.applications.ListApplicationsRequest.OrderDirection = {
  ASC: 0,
  DESC: 1
};

/**
 * optional OrderBy order_by = 1;
 * @return {!proto.pushwoosh.rpc_v2.applications.ListApplicationsRequest.OrderBy}
 */
proto.pushwoosh.rpc_v2.applications.ListApplicationsRequest.prototype.getOrderBy = function() {
  return /** @type {!proto.pushwoosh.rpc_v2.applications.ListApplicationsRequest.OrderBy} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.pushwoosh.rpc_v2.applications.ListApplicationsRequest.OrderBy} value
 * @return {!proto.pushwoosh.rpc_v2.applications.ListApplicationsRequest} returns this
 */
proto.pushwoosh.rpc_v2.applications.ListApplicationsRequest.prototype.setOrderBy = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional OrderDirection order_direction = 2;
 * @return {!proto.pushwoosh.rpc_v2.applications.ListApplicationsRequest.OrderDirection}
 */
proto.pushwoosh.rpc_v2.applications.ListApplicationsRequest.prototype.getOrderDirection = function() {
  return /** @type {!proto.pushwoosh.rpc_v2.applications.ListApplicationsRequest.OrderDirection} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.pushwoosh.rpc_v2.applications.ListApplicationsRequest.OrderDirection} value
 * @return {!proto.pushwoosh.rpc_v2.applications.ListApplicationsRequest} returns this
 */
proto.pushwoosh.rpc_v2.applications.ListApplicationsRequest.prototype.setOrderDirection = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional int32 page = 3;
 * @return {number}
 */
proto.pushwoosh.rpc_v2.applications.ListApplicationsRequest.prototype.getPage = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.pushwoosh.rpc_v2.applications.ListApplicationsRequest} returns this
 */
proto.pushwoosh.rpc_v2.applications.ListApplicationsRequest.prototype.setPage = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int32 per_page = 4;
 * @return {number}
 */
proto.pushwoosh.rpc_v2.applications.ListApplicationsRequest.prototype.getPerPage = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.pushwoosh.rpc_v2.applications.ListApplicationsRequest} returns this
 */
proto.pushwoosh.rpc_v2.applications.ListApplicationsRequest.prototype.setPerPage = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional string search = 5;
 * @return {string}
 */
proto.pushwoosh.rpc_v2.applications.ListApplicationsRequest.prototype.getSearch = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.pushwoosh.rpc_v2.applications.ListApplicationsRequest} returns this
 */
proto.pushwoosh.rpc_v2.applications.ListApplicationsRequest.prototype.setSearch = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.pushwoosh.rpc_v2.applications.ListApplicationsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.rpc_v2.applications.ListApplicationsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.rpc_v2.applications.ListApplicationsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.rpc_v2.applications.ListApplicationsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.applications.ListApplicationsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    applicationsList: jspb.Message.toObjectList(msg.getApplicationsList(),
    proto.pushwoosh.rpc_v2.applications.ApplicationSummary.toObject, includeInstance),
    page: jspb.Message.getFieldWithDefault(msg, 2, 0),
    perPage: jspb.Message.getFieldWithDefault(msg, 3, 0),
    total: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.rpc_v2.applications.ListApplicationsResponse}
 */
proto.pushwoosh.rpc_v2.applications.ListApplicationsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.rpc_v2.applications.ListApplicationsResponse;
  return proto.pushwoosh.rpc_v2.applications.ListApplicationsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.rpc_v2.applications.ListApplicationsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.rpc_v2.applications.ListApplicationsResponse}
 */
proto.pushwoosh.rpc_v2.applications.ListApplicationsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.pushwoosh.rpc_v2.applications.ApplicationSummary;
      reader.readMessage(value,proto.pushwoosh.rpc_v2.applications.ApplicationSummary.deserializeBinaryFromReader);
      msg.addApplications(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPage(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPerPage(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotal(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.rpc_v2.applications.ListApplicationsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.rpc_v2.applications.ListApplicationsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.rpc_v2.applications.ListApplicationsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.applications.ListApplicationsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getApplicationsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.pushwoosh.rpc_v2.applications.ApplicationSummary.serializeBinaryToWriter
    );
  }
  f = message.getPage();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getPerPage();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getTotal();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
};


/**
 * repeated ApplicationSummary applications = 1;
 * @return {!Array<!proto.pushwoosh.rpc_v2.applications.ApplicationSummary>}
 */
proto.pushwoosh.rpc_v2.applications.ListApplicationsResponse.prototype.getApplicationsList = function() {
  return /** @type{!Array<!proto.pushwoosh.rpc_v2.applications.ApplicationSummary>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.pushwoosh.rpc_v2.applications.ApplicationSummary, 1));
};


/**
 * @param {!Array<!proto.pushwoosh.rpc_v2.applications.ApplicationSummary>} value
 * @return {!proto.pushwoosh.rpc_v2.applications.ListApplicationsResponse} returns this
*/
proto.pushwoosh.rpc_v2.applications.ListApplicationsResponse.prototype.setApplicationsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.pushwoosh.rpc_v2.applications.ApplicationSummary=} opt_value
 * @param {number=} opt_index
 * @return {!proto.pushwoosh.rpc_v2.applications.ApplicationSummary}
 */
proto.pushwoosh.rpc_v2.applications.ListApplicationsResponse.prototype.addApplications = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.pushwoosh.rpc_v2.applications.ApplicationSummary, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.pushwoosh.rpc_v2.applications.ListApplicationsResponse} returns this
 */
proto.pushwoosh.rpc_v2.applications.ListApplicationsResponse.prototype.clearApplicationsList = function() {
  return this.setApplicationsList([]);
};


/**
 * optional int32 page = 2;
 * @return {number}
 */
proto.pushwoosh.rpc_v2.applications.ListApplicationsResponse.prototype.getPage = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.pushwoosh.rpc_v2.applications.ListApplicationsResponse} returns this
 */
proto.pushwoosh.rpc_v2.applications.ListApplicationsResponse.prototype.setPage = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 per_page = 3;
 * @return {number}
 */
proto.pushwoosh.rpc_v2.applications.ListApplicationsResponse.prototype.getPerPage = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.pushwoosh.rpc_v2.applications.ListApplicationsResponse} returns this
 */
proto.pushwoosh.rpc_v2.applications.ListApplicationsResponse.prototype.setPerPage = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int32 total = 4;
 * @return {number}
 */
proto.pushwoosh.rpc_v2.applications.ListApplicationsResponse.prototype.getTotal = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.pushwoosh.rpc_v2.applications.ListApplicationsResponse} returns this
 */
proto.pushwoosh.rpc_v2.applications.ListApplicationsResponse.prototype.setTotal = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.rpc_v2.applications.DeleteApplicationRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.rpc_v2.applications.DeleteApplicationRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.rpc_v2.applications.DeleteApplicationRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.applications.DeleteApplicationRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    code: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.rpc_v2.applications.DeleteApplicationRequest}
 */
proto.pushwoosh.rpc_v2.applications.DeleteApplicationRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.rpc_v2.applications.DeleteApplicationRequest;
  return proto.pushwoosh.rpc_v2.applications.DeleteApplicationRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.rpc_v2.applications.DeleteApplicationRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.rpc_v2.applications.DeleteApplicationRequest}
 */
proto.pushwoosh.rpc_v2.applications.DeleteApplicationRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCode(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.rpc_v2.applications.DeleteApplicationRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.rpc_v2.applications.DeleteApplicationRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.rpc_v2.applications.DeleteApplicationRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.applications.DeleteApplicationRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCode();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string code = 1;
 * @return {string}
 */
proto.pushwoosh.rpc_v2.applications.DeleteApplicationRequest.prototype.getCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.pushwoosh.rpc_v2.applications.DeleteApplicationRequest} returns this
 */
proto.pushwoosh.rpc_v2.applications.DeleteApplicationRequest.prototype.setCode = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.rpc_v2.applications.DeleteApplicationResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.rpc_v2.applications.DeleteApplicationResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.rpc_v2.applications.DeleteApplicationResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.applications.DeleteApplicationResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.rpc_v2.applications.DeleteApplicationResponse}
 */
proto.pushwoosh.rpc_v2.applications.DeleteApplicationResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.rpc_v2.applications.DeleteApplicationResponse;
  return proto.pushwoosh.rpc_v2.applications.DeleteApplicationResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.rpc_v2.applications.DeleteApplicationResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.rpc_v2.applications.DeleteApplicationResponse}
 */
proto.pushwoosh.rpc_v2.applications.DeleteApplicationResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.rpc_v2.applications.DeleteApplicationResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.rpc_v2.applications.DeleteApplicationResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.rpc_v2.applications.DeleteApplicationResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.applications.DeleteApplicationResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.rpc_v2.applications.SetShortenerConfigurationRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.rpc_v2.applications.SetShortenerConfigurationRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.rpc_v2.applications.SetShortenerConfigurationRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.applications.SetShortenerConfigurationRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    code: jspb.Message.getFieldWithDefault(msg, 1, ""),
    bitlyAccessToken: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.rpc_v2.applications.SetShortenerConfigurationRequest}
 */
proto.pushwoosh.rpc_v2.applications.SetShortenerConfigurationRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.rpc_v2.applications.SetShortenerConfigurationRequest;
  return proto.pushwoosh.rpc_v2.applications.SetShortenerConfigurationRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.rpc_v2.applications.SetShortenerConfigurationRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.rpc_v2.applications.SetShortenerConfigurationRequest}
 */
proto.pushwoosh.rpc_v2.applications.SetShortenerConfigurationRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCode(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setBitlyAccessToken(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.rpc_v2.applications.SetShortenerConfigurationRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.rpc_v2.applications.SetShortenerConfigurationRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.rpc_v2.applications.SetShortenerConfigurationRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.applications.SetShortenerConfigurationRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCode();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getBitlyAccessToken();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string code = 1;
 * @return {string}
 */
proto.pushwoosh.rpc_v2.applications.SetShortenerConfigurationRequest.prototype.getCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.pushwoosh.rpc_v2.applications.SetShortenerConfigurationRequest} returns this
 */
proto.pushwoosh.rpc_v2.applications.SetShortenerConfigurationRequest.prototype.setCode = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string bitly_access_token = 2;
 * @return {string}
 */
proto.pushwoosh.rpc_v2.applications.SetShortenerConfigurationRequest.prototype.getBitlyAccessToken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.pushwoosh.rpc_v2.applications.SetShortenerConfigurationRequest} returns this
 */
proto.pushwoosh.rpc_v2.applications.SetShortenerConfigurationRequest.prototype.setBitlyAccessToken = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.rpc_v2.applications.SetShortenerConfigurationResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.rpc_v2.applications.SetShortenerConfigurationResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.rpc_v2.applications.SetShortenerConfigurationResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.applications.SetShortenerConfigurationResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.rpc_v2.applications.SetShortenerConfigurationResponse}
 */
proto.pushwoosh.rpc_v2.applications.SetShortenerConfigurationResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.rpc_v2.applications.SetShortenerConfigurationResponse;
  return proto.pushwoosh.rpc_v2.applications.SetShortenerConfigurationResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.rpc_v2.applications.SetShortenerConfigurationResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.rpc_v2.applications.SetShortenerConfigurationResponse}
 */
proto.pushwoosh.rpc_v2.applications.SetShortenerConfigurationResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.rpc_v2.applications.SetShortenerConfigurationResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.rpc_v2.applications.SetShortenerConfigurationResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.rpc_v2.applications.SetShortenerConfigurationResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.applications.SetShortenerConfigurationResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


goog.object.extend(exports, proto.pushwoosh.rpc_v2.applications);
